var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 299,
    viewBox: "0 0 1440 299",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_93_45",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 299
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 299,
    fill: "#F0EFF0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_93_45)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 780,
    cy: 114.5,
    rx: 109,
    ry: 78.5,
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1219,
    cy: 172.5,
    rx: 78,
    ry: 78.5,
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1302.5,
    cy: 209.5,
    rx: 88.5,
    ry: 78.5,
    fill: "#F0EFF0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1331,
    cy: 241.5,
    rx: 109,
    ry: 78.5,
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 917.507,
    cy: 174.084,
    rx: 131.507,
    ry: 131.084,
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1110,
    cy: 142.5,
    rx: 109,
    ry: 78.5,
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 338.204,
    cy: 193.781,
    rx: 122.204,
    ry: 121.781,
    fill: "#F0EFF0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 131,
    cy: 238.5,
    rx: 109,
    ry: 78.5,
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 124,
    cy: 338.5,
    rx: 109,
    ry: 78.5,
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.204,
    cy: 230.781,
    rx: 122.204,
    ry: 121.781,
    fill: "#F0EFF0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 335.204,
    cy: 235.781,
    rx: 122.204,
    ry: 121.781,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 409.812,
    cy: 243.643,
    rx: 122.204,
    ry: 121.781,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 487.617,
    cy: 200.512,
    rx: 122.204,
    ry: 121.781,
    fill: "#F0EFF0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 552.736,
    cy: 268.168,
    rx: 122.204,
    ry: 121.781,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 552.204,
    cy: 176.781,
    rx: 122.204,
    ry: 121.781,
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 579.376,
    cy: 227.151,
    rx: 105.713,
    ry: 105.29,
    fill: "#E5E5E5",
    fillOpacity: 0.93
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 677.713,
    cy: 181.29,
    rx: 105.713,
    ry: 105.29,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 801.713,
    cy: 150.29,
    rx: 105.713,
    ry: 105.29,
    fill: "#F0EFF0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1062.7,
    cy: 296.076,
    rx: 106.981,
    ry: 106.559,
    fill: "#F0EFF0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1110.9,
    cy: 203.895,
    rx: 106.981,
    ry: 106.559,
    fill: "#F0EFF0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 923.5,
    cy: 150,
    rx: 99.5,
    ry: 99,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1246.5,
    cy: 221,
    rx: 99.5,
    ry: 99,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 966.981,
    cy: 170.559,
    rx: 106.981,
    ry: 106.559,
    fill: "#F0EFF0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 446.981,
    cy: 149.559,
    rx: 106.981,
    ry: 106.559,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1255.98,
    cy: 249.559,
    rx: 106.981,
    ry: 106.559,
    fill: "#F0EFF0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.9814,
    cy: 314.559,
    rx: 106.981,
    ry: 106.559,
    fill: "#F0EFF0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.981,
    cy: 270.559,
    rx: 106.981,
    ry: 106.559,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.981,
    cy: 298.559,
    rx: 106.981,
    ry: 106.559,
    fill: "#F0EFF0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 397.973,
    cy: 248.717,
    rx: 84.1475,
    ry: 83.7246,
    fill: "#E5E5E5",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 441.713,
    cy: 159.29,
    rx: 105.713,
    ry: 105.29,
    fill: "#F0EFF0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 536.713,
    cy: 201.29,
    rx: 105.713,
    ry: 105.29,
    fill: "#F0EFF0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 557.713,
    cy: 170.29,
    rx: 105.713,
    ry: 105.29,
    fill: "#F0EFF0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 315.5,
    cy: 232,
    rx: 101.5,
    ry: 105,
    fill: "#F0EFF0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 748.517,
    cy: 260.134,
    rx: 105.713,
    ry: 105.29,
    fill: "#F0EFF0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 486.981,
    cy: 189.559,
    rx: 106.981,
    ry: 106.559,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 625.981,
    cy: 249.559,
    rx: 106.981,
    ry: 106.559,
    fill: "#F0EFF0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 512,
    cy: 204.5,
    rx: 127,
    ry: 109.5,
    fill: "#F0EFF0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 704.5,
    cy: 163,
    rx: 76.5,
    ry: 76,
    fill: "#F0EFF0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 558,
    cy: 240.5,
    rx: 127,
    ry: 109.5,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 558,
    cy: 255.5,
    rx: 127,
    ry: 109.5,
    fill: "#E9E8E8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 698.981,
    cy: 219.559,
    rx: 106.981,
    ry: 106.559,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 690.981,
    cy: 235.559,
    rx: 106.981,
    ry: 106.559,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 848.5,
    cy: 185,
    rx: 99.5,
    ry: 99,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 863.5,
    cy: 198,
    rx: 119.5,
    ry: 115,
    fill: "#E9E8E8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 861.5,
    cy: 206,
    rx: 119.5,
    ry: 115,
    fill: "#F0EFF0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 646.5,
    cy: 268,
    rx: 76.5,
    ry: 76,
    fill: "#F0EFF0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 912.5,
    cy: 254,
    rx: 76.5,
    ry: 76,
    fill: "#F0EFF0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 624.5,
    cy: 221,
    rx: 76.5,
    ry: 76,
    fill: "#F0EFF0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 679.5,
    cy: 242,
    rx: 99.5,
    ry: 99,
    fill: "#F0EFF0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 519.5,
    cy: 264,
    rx: 99.5,
    ry: 99,
    fill: "#F0EFF0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 341.5,
    cy: 254,
    rx: 99.5,
    ry: 99,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 415,
    cy: 249.5,
    rx: 64,
    ry: 63.5,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 212,
    cy: 223.5,
    rx: 64,
    ry: 63.5,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 341.5,
    cy: 268,
    rx: 99.5,
    ry: 99,
    fill: "#F0EFF0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 232.5,
    cy: 273,
    rx: 99.5,
    ry: 99,
    fill: "#F0EFF0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 447.5,
    cy: 292,
    rx: 99.5,
    ry: 99,
    fill: "#F0EFF0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1362.05,
    cy: 290.735,
    rx: 106.981,
    ry: 106.559,
    transform: "rotate(-13.606 1362.05 290.735)",
    fill: "#F0EFF0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.6fb6ff3375b4756de363a50404f3321e.svg";
export { ForwardRef as ReactComponent };